import { createRoot } from 'react-dom/client';
import { StaticRouter } from 'react-router-dom';

import { getClientLocale, I18NProvider } from '@utils/i18n';
import apolloWrapper from '@hoc/apolloWrapper';
import SearchSubscribeTelegramContainer from '@containers/SearchSubscribeTelegramContainer';
import SearchSubscribeTelegramTopContainer from '@containers/SearchSubscribeTelegramTopContainer';
import ToastContainer from '@components/ToastContainer';

export const renderSearchSubscriberBlock = () => {
  const saveSearchBlock = document
    .querySelector('#js-search-subscribe');

  const SearchSubscribeTelegramContainerApollo = apolloWrapper(
    SearchSubscribeTelegramContainer,
  );

  if (saveSearchBlock) {
    const root = createRoot(saveSearchBlock);
    const { lang, routerBasename } = getClientLocale();

    root.render(
      <StaticRouter
        location={window.location}
        basename={routerBasename}
      >
        <I18NProvider lang={lang}>
          {() => (
            <>
              <SearchSubscribeTelegramContainerApollo />
            </>
          )}
        </I18NProvider>
      </StaticRouter>,
    );
  }

  const saveSearchTopBlocks = document
    .querySelectorAll('#js-search-subscribe-top');
  const SearchSubscribeTelegramTopContainerApollo = apolloWrapper(
    SearchSubscribeTelegramTopContainer,
  );
  if (saveSearchTopBlocks.length) {
    const { lang, routerBasename } = getClientLocale();
    saveSearchTopBlocks.forEach((saveSearchTopBlock) => {
      const filter = saveSearchTopBlock.getAttribute('data-filter');
      const productId = saveSearchTopBlock.getAttribute('data-first-productId');
      const root = createRoot(saveSearchTopBlock);

      root.render(
        <StaticRouter
          location={window.location}
          basename={routerBasename}
        >
          <I18NProvider lang={lang}>
            {() => (
              <>
                <ToastContainer />
                <SearchSubscribeTelegramTopContainerApollo filter={filter || ''} productId={productId} />
              </>
            )}
          </I18NProvider>
        </StaticRouter>,
      );
    });
  }
};

// first initialization
renderSearchSubscriberBlock();
